import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {CalendarSchedule, CalendarScheduleSearchParams} from '@accounting/_common/models/calendar.models';

export const CheckState = createAction(
    '[CalendarSchedules] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: CalendarSchedule[] } }>()
);

export const CheckStateSuccess = createAction(
    '[CalendarSchedules] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: CalendarSchedule[] } }>()
);

export const LoadList = createAction(
    '[CalendarSchedules] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[CalendarSchedules] Load List Success',
    props<{ payload: { items: CalendarSchedule[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[CalendarSchedules] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[CalendarSchedules] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[CalendarSchedules] Set Filter',
    props<{ payload: CalendarScheduleSearchParams }>()
);

export const SetLoading = createAction(
    '[CalendarSchedules] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[CalendarSchedules] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[CalendarSchedules] Update Item Success',
    props<{ payload: CalendarSchedule }>()
);

export const DeleteItem = createAction(
    '[CalendarSchedules] Delete Item',
    props<{ payload: CalendarSchedule }>()
);

export const DeleteItemSuccess = createAction(
    '[CalendarSchedules] Delete Item Success',
    props<{ payload: CalendarSchedule }>()
);

export const DeleteItemFailure = createAction(
    '[CalendarSchedules] Delete Item Failure',
    props<{ payload: CalendarSchedule }>()
);

export const SetInitialState = createAction(
    '[CalendarSchedules] Set Initial State'
);

export const UpdateCalendarScheduleItem = createAction(
    '[CalendarSchedules] Update CalendarSchedules Item',
    props<{ payload: CalendarSchedule }>()
);
